<template>
  <div class="cheers">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0">
      <div class="row">
        <div
          class="
            col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12
            d-flex
            align-items-center
          "
        >
          <h1 class="title-pages">SINAIS VITAIS</h1>
        </div>
        <div
          v-if="$store.state.online"
          class="col-xl-3 col-lg-3 col-md-4 col-sm-7 col-12 pb-0"
        >
          <v-select
            style="z-index: 999 !important"
            @input="getVitalSigns"
            label="FILTRAR PRÓXIMAS/ANTERIORES"
            v-model="next_or_previous"
            :items="[
              { value: 'PREV', text: 'DATAS ANTERIORES' },
              { value: 'NEXT', text: 'PRÓXIMAS DATAS' },
            ]"
            dense
            outlined
            item-value="value"
            item-text="text"
          />
        </div>
        <div
          v-if="$store.state.online"
          class="col-xl-3 col-lg-3 col-md-4 col-sm-7 col-12 pb-0"
        >
          <v-text-field
            label="DATA"
            outlined
            dense
            type="date"
            v-model="date"
            @input="getVitalSigns"
          />
        </div>
        <div
          :class="[
            'pb-0 text-right',
            $store.state.online
              ? 'col-xl-2 col-lg-2 col-md-3 col-sm-7 col-12'
              : 'col-xl-8 col-lg-8 col-md-6 col-sm-12 col-12',
          ]"
        >
          <v-btn
            v-if="$store.state.online"
            v-on:click="print"
            class="btn-print m-2"
          >
            <i class="fas fa-print mr-2 text-twenty"></i>
            IMPRIMIR
          </v-btn>
        </div>
      </div>
      <b-overlay :show="loadingVitalSigns" opacity="0.99" class="bg-white">
        <ErrorsMessages :errors="errorsVitalSigns" />
        <table class="table table-responsive table-bordered tableFixHead">
          <thead>
            <tr>
              <th class="text-two text-center">MEDIÇÃO VITAL</th>
              <th
                class="text-center"
                v-for="item in vital_signs"
                :key="item.date"
              >
                {{ formatDate(item.date, false) }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="type in typesVitalSigns" :key="type.type">
              <td style="width: 10% !important" class="text-two text-center">
                <strong>{{ type }}</strong>
              </td>
              <td v-for="(vital_sign, key) in vital_signs" :key="key">
                <div
                  class="text-center text-thirteen"
                  v-if="
                    vital_sign.care_vital_signs.length == 0 &&
                    vital_sign.care_has_feeding_care.length == 0
                  "
                >
                  --
                </div>
                <div
                  v-if="
                    type == TYPE_ALIMENTACAO &&
                    vital_sign.care_has_feeding_care.length > 0
                  "
                >
                  <div
                    class="text-center"
                    v-for="item in vital_sign.care_has_feeding_care"
                    :key="item.id"
                  >
                    <button
                      :class="[
                        'mb-1 border-for btn-block',
                        item.response == 'BOA ACEITAÇÃO' &&
                          'bg-success text-white',
                        item.response == 'ACEITOU PARCIAL' &&
                          'bg-warning text-dark',
                        item.response == 'NÃO ACEITOU' &&
                          'bg-danger text-white',
                      ]"
                      :content="`
                        ${formatDate(item.created_at)} 
                        -
                        ${item.name}
                        -
                        ${item.response}
                        <br />
                        CADASTRADO POR: ${item.user_name}`"
                      v-tippy="{
                        followCursor: true,
                      }"
                    >
                      <span class="text-eleven upper-text">
                        {{ item.name }} - {{ item.response }}
                      </span>
                    </button>
                  </div>
                </div>
                <div
                  class="text-center"
                  v-for="(
                    care_vital_sign, index
                  ) in vital_sign.care_vital_signs"
                  :key="index"
                >
                  <div
                    v-for="item in care_vital_sign.care_has_vital_signs"
                    :key="item.id"
                    v-show="item.type == type"
                  >
                    <div v-if="type == TYPE_DIURESE">
                      <div
                        v-if="care_vital_sign.care_has_vital_signs.length > 0"
                      >
                        <button
                          :class="[
                            'mb-1 border-for btn-block',
                            item.description == 'POUCA DIURESE' &&
                              'bg-warning text-dark',
                            item.description == 'DIURESE PRESENTE' &&
                              'bg-success text-white',
                            item.description == 'AUSÊNCIA DE DIURESE' &&
                              'bg-danger text-white',
                          ]"
                          :content="`
                              ${formatDate(item.created_at)} 
                              -
                              ${item.description}
                              <br />
                              CADASTRADO POR: ${item.user_name}
                              `"
                          v-tippy="{
                            followCursor: true,
                          }"
                        >
                          <span class="text-eleven upper-text">
                            {{ item.description }}
                          </span>
                        </button>
                      </div>
                    </div>
                    <div v-if="type == TYPE_DOR">
                      <div
                        v-if="care_vital_sign.care_has_vital_signs.length > 0"
                      >
                        <button
                          :class="[
                            'mb-1 border-for btn-block',
                            parseInt(item.description) >= 0 &&
                              parseInt(item.description) <= 3 &&
                              'bg-success text-white',
                            parseInt(item.description) >= 4 &&
                              parseInt(item.description) <= 7 &&
                              'bg-warning text-dark',
                            parseInt(item.description) >= 8 &&
                              parseInt(item.description) <= 10 &&
                              'bg-danger text-white',
                          ]"
                          :content="`
                              ${formatDate(item.created_at)} 
                              -
                              ${handleDescriptionAche(item.description)}
                              <br />
                              CADASTRADO POR: ${item.user_name}`"
                          v-tippy="{
                            followCursor: true,
                          }"
                        >
                          <span class="text-eleven upper-text">
                            {{ handleDescriptionAche(item.description) }}
                          </span>
                        </button>
                      </div>
                    </div>
                    <div v-if="type == TYPE_EVACUACAO">
                      <div
                        v-if="care_vital_sign.care_has_vital_signs.length > 0"
                      >
                        <button
                          :class="[
                            'mb-1 border-for btn-block',
                            item.description == 'PASTOSA' &&
                              'bg-warning text-dark',
                            item.description == 'EM CÍBALOS' &&
                              'bg-warning text-dark',
                            item.description == 'BEM MOLDADAS' &&
                              'bg-success text-white',
                            item.description == 'AUSENTE' &&
                              'bg-danger text-white',
                            item.description == 'LÍQUIDA' &&
                              'bg-danger text-white',
                          ]"
                          :content="`
                              ${formatDate(item.created_at)} 
                              -
                              ${item.description}
                              <br />
                              CADASTRADO POR: ${item.user_name}`"
                          v-tippy="{
                            followCursor: true,
                          }"
                        >
                          <span class="text-eleven upper-text">
                            {{ item.description }}
                          </span>
                        </button>
                      </div>
                    </div>
                    <div v-if="type == TYPE_FREQUENCIA_RESPIRATORIA">
                      <div
                        v-if="care_vital_sign.care_has_vital_signs.length > 0"
                      >
                        <button
                          :class="[
                            'mb-1 border-for btn-block',
                            parseInt(item.description) >= 10 &&
                              parseInt(item.description) <= 20 &&
                              'bg-success text-white',
                            parseInt(item.description) >= 21 &&
                              parseInt(item.description) <= 34 &&
                              'bg-warning text-dark',
                            (parseInt(item.description) < 10 ||
                              parseInt(item.description) > 34) &&
                              'bg-danger text-white',
                          ]"
                          :content="`
                              ${formatDate(item.created_at)} 
                              -
                              ${item.description}
                              ${item.abbreviation}
                              <br />
                              CADASTRADO POR: ${item.user_name}`"
                          v-tippy="{
                            followCursor: true,
                          }"
                        >
                          <span class="text-eleven upper-text">
                            {{ item.description }}
                            {{ item.abbreviation }}
                          </span>
                        </button>
                      </div>
                    </div>
                    <div v-if="type == TYPE_GLICEMIA_CAPILAR">
                      <div
                        v-if="care_vital_sign.care_has_vital_signs.length > 0"
                      >
                        <button
                          :class="[
                            'mb-1 border-for btn-block',
                            parseInt(item.description) >= 70 &&
                              parseInt(item.description) <= 110 &&
                              'bg-success text-white',
                            parseInt(item.description) >= 51 &&
                              parseInt(item.description) <= 69 &&
                              'bg-warning text-dark',
                            parseInt(item.description) >= 111 &&
                              parseInt(item.description) <= 125 &&
                              'bg-warning text-dark',
                            (parseInt(item.description) >= 126 ||
                              parseInt(item.description) <= 51) &&
                              'bg-danger text-white',
                          ]"
                          :content="`
                              ${formatDate(item.created_at)} 
                              -
                              ${item.description}
                              ${item.abbreviation}
                              <br />
                              CADASTRADO POR: ${item.user_name}`"
                          v-tippy="{
                            followCursor: true,
                          }"
                        >
                          <span class="text-eleven upper-text">
                            {{ item.description }}
                            {{ item.abbreviation }}
                          </span>
                        </button>
                      </div>
                    </div>
                    <div v-if="type == TYPE_PRESSAO_ARTERIAL">
                      <div
                        v-if="care_vital_sign.care_has_vital_signs.length > 0"
                      >
                        <button
                          :class="[
                            'mb-1 border-for btn-block',
                            handleColorBloodPressure(
                              item.initial_description,
                              item.final_description
                            ),
                          ]"
                          :content="`
                              ${formatDate(item.created_at)} 
                              -
                              ${item.description}
                              ${item.abbreviation}
                              <br />
                              CADASTRADO POR: ${item.user_name}`"
                          v-tippy="{
                            followCursor: true,
                          }"
                        >
                          <span class="text-eleven upper-text">
                            {{ item.description }}
                            {{ item.abbreviation }}
                          </span>
                        </button>
                      </div>
                    </div>
                    <div v-if="type == TYPE_PULSO_FREQUENCIA_CARDIACA">
                      <div
                        v-if="care_vital_sign.care_has_vital_signs.length > 0"
                      >
                        <button
                          :class="[
                            'mb-1 border-for btn-block',
                            parseInt(item.description) >= 60 &&
                              parseInt(item.description) <= 100 &&
                              'bg-success text-white',
                            parseInt(item.description) >= 101 &&
                              parseInt(item.description) <= 139 &&
                              'bg-warning text-dark',
                            parseInt(item.description) >= 41 &&
                              parseInt(item.description) <= 59 &&
                              'bg-warning text-dark',
                            parseInt(item.description) >= 140 &&
                              parseInt(item.description) <= 40 &&
                              'bg-danger text-white',
                          ]"
                          :content="`
                              ${formatDate(item.created_at)} 
                              -
                              ${item.description}
                              ${item.abbreviation}
                              <br />
                              CADASTRADO POR: ${item.user_name}`"
                          v-tippy="{
                            followCursor: true,
                          }"
                        >
                          <span class="text-eleven upper-text">
                            {{ item.description }}
                            {{ item.abbreviation }}
                          </span>
                        </button>
                      </div>
                    </div>
                    <div v-if="type == TYPE_SATURACAO_DE_OXIGENIO">
                      <div
                        v-if="care_vital_sign.care_has_vital_signs.length > 0"
                      >
                        <button
                          :class="[
                            'mb-1 border-for btn-block',
                            parseInt(item.description) >= 92 &&
                              parseInt(item.description) <= 100 &&
                              'bg-success text-white',
                            parseInt(item.description) >= 88 &&
                              parseInt(item.description) <= 91 &&
                              'bg-warning text-dark',
                            parseInt(item.description) <= 87 &&
                              'bg-danger text-white',
                          ]"
                          :content="`
                              ${formatDate(item.created_at)} 
                              -
                              ${item.description}
                              ${item.abbreviation}
                              <br />
                              CADASTRADO POR: ${item.user_name}`"
                          v-tippy="{
                            followCursor: true,
                          }"
                        >
                          <span class="text-eleven upper-text">
                            {{ item.description }}
                            {{ item.abbreviation }}
                          </span>
                        </button>
                      </div>
                    </div>
                    <div v-if="type == TYPE_TEMPERATURA_CORPORAL">
                      <div
                        v-if="care_vital_sign.care_has_vital_signs.length > 0"
                      >
                        <button
                          :class="[
                            'mb-1 border-for btn-block',
                            parseFloat(item.description) >= 36.1 &&
                              parseFloat(item.description) <= 37.2 &&
                              'bg-success text-white',
                            parseFloat(item.description) >= 37.3 &&
                              parseFloat(item.description) <= 38.4 &&
                              'bg-warning text-dark',
                            parseFloat(item.description) >= 35.1 &&
                              parseFloat(item.description) <= 36 &&
                              'bg-warning text-dark',
                            (parseFloat(item.description) > 38.4 ||
                              parseFloat(item.description) < 35.1) &&
                              'bg-danger text-white',
                          ]"
                          :content="`
                              ${formatDate(item.created_at)} 
                              -
                              ${item.description}
                              ${item.abbreviation}
                              <br />
                              CADASTRADO POR: ${item.user_name}`"
                          v-tippy="{
                            followCursor: true,
                          }"
                        >
                          <span class="text-eleven upper-text">
                            {{ item.description }}
                            {{ item.abbreviation }}
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages";

import routes from "../../../routes";

import api from "../../../services/api";

import { formatDate } from "../../../lib/format";

import { getStatic } from "../../../lib/functions";

import moment from "moment";

export default {
  name: "Cheers",
  components: {
    ErrorsMessages,
  },
  data() {
    return {
      accessed_offline: false,
      resident_id: "",
      next_or_previous: "PREV",
      date: moment().format("YYYY-MM-DD"),
      loadingVitalSigns: false,
      vital_signs: [],
      errorsVitalSigns: [],
      typesVitalSigns: [
        "ALIMENTAÇÃO",
        "DIURESE",
        "DOR",
        "EVACUAÇÃO",
        "FREQUÊNCIA RESPIRATÓRIA",
        "GLICEMIA CAPILAR",
        "PRESSÃO ARTERIAL",
        "PULSO (FREQUÊNCIA CARDÍACA)",
        "SATURAÇÃO DE OXIGÊNIO",
        "TEMPERATURA CORPORAL",
      ],
      TYPE_ALIMENTACAO: "ALIMENTAÇÃO",
      TYPE_DIURESE: "DIURESE",
      TYPE_DOR: "DOR",
      TYPE_EVACUACAO: "EVACUAÇÃO",
      TYPE_FREQUENCIA_RESPIRATORIA: "FREQUÊNCIA RESPIRATÓRIA",
      TYPE_GLICEMIA_CAPILAR: "GLICEMIA CAPILAR",
      TYPE_PRESSAO_ARTERIAL: "PRESSÃO ARTERIAL",
      TYPE_PULSO_FREQUENCIA_CARDIACA: "PULSO (FREQUÊNCIA CARDÍACA)",
      TYPE_SATURACAO_DE_OXIGENIO: "SATURAÇÃO DE OXIGÊNIO",
      TYPE_TEMPERATURA_CORPORAL: "TEMPERATURA CORPORAL",
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    formatDate,
    handleColorBloodPressure(initial, final) {
      if (parseInt(initial) >= 100 && parseInt(initial) <= 140) {
        if (parseInt(final) >= 60 && parseInt(final) <= 90) {
          return "bg-success text-white";
        }
        if (parseInt(final) >= 50 && parseInt(final) <= 59) {
          return "bg-warning text-dark";
        }
      }

      if (parseInt(initial) >= 141 && parseInt(initial) <= 179) {
        if (parseInt(final) >= 91 && parseInt(final) <= 109) {
          return "bg-warning text-dark";
        } else {
          return "bg-danger text-white";
        }
      }

      return "bg-danger text-white";
    },
    handleDescriptionAche(nivel) {
      if (parseInt(nivel) == 0) {
        return "SEM DOR";
      } else if (parseInt(nivel) >= 1 && parseInt(nivel) <= 3) {
        return "DOR LEVE";
      } else if (parseInt(nivel) >= 4 && parseInt(nivel) <= 7) {
        return "DOR MODERADA";
      } else if (parseInt(nivel) >= 8 && parseInt(nivel) <= 10) {
        return "DOR INTENSA";
      }
    },
    async retrieve() {
      const { id } = routes.history.current.params;
      this.resident_id = id;

      let accessed_offline = JSON.parse(
        sessionStorage.getItem("accessed_offline") || !this.$store.state.online
      );

      this.accessed_offline = accessed_offline;

      if (accessed_offline) {
        let residents = (await getStatic("/offline/residents", true)).residents;

        let resident = residents.filter((item) => item.id == id);

        if (resident[0]) {
          this.vital_signs = resident[0].cheers;
        }

        this.loadingVitalSigns = false;
      } else {
        await this.getVitalSigns();
      }
    },
    async getVitalSigns() {
      try {
        this.loadingVitalSigns = true;

        const { resident_id, next_or_previous, date } = this;

        let params = { resident_id, next_or_previous, date };

        const response = await api.get(
          "/rest-home/resident/cheers-vital-signs",
          {
            params,
          }
        );

        const { vital_signs, error, errors } = response.data;

        if (error) {
          this.errorsVitalSigns = errors;
        } else {
          this.vital_signs = vital_signs;
          this.errorsVitalSigns = [];
        }

        this.loadingVitalSigns = false;
      } catch (error) {
        console.log(error);
      }
    },
    print() {
      const { resident_id, date, next_or_previous } = this;

      let route = this.$router.resolve({
        name: "print-cheers",
        params: {
          resident_id,
          date,
          next_or_previous,
        },
      });

      window.open(route.href, "_blank");
    },
  },
};
</script>

<style>
.cheers .tableFixHead {
  overflow-y: auto;
  height: 500px;
}
.cheers .tableFixHead thead th {
  background: #fff;
  z-index: 999;
  position: sticky;
  top: 0;
}
</style>
